
<template>
    <div class="container2">
		<div class="cusApro-search" :style="collapse ? 'height: 40px' : ''">
			<div class="search-box">
				<div class="input-box">
					<span>客户名称：</span>
					<el-input
						v-model="cusName"
						placeholder="请输入客户名称"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						v-model="pName"
						placeholder="请输入商品名称"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>客户类别：</span>
					<el-select v-model="cusCateIds" class="name-input" size='mini'>
						<el-option value="" label="全部"></el-option>
						<el-option v-for="item in cusCateList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>店铺级大类：</span>
					<el-select v-model="bcId" class="name-input" size='mini' @change="bcChange">
						<el-option value="" label="全部"></el-option>
						<template v-for="(item) in bc">
							<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
						</template>
					</el-select>
				</div>
				<div class="input-box" v-if="bigcategoryview === 1">
					<span>店铺级小类：</span>
					<el-select v-model="scId" class="name-input" size='mini'>
						<el-option value="" label="全部"></el-option>
						<template v-for="(item) in sc">
							<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>SPU编号：</span>
					<el-input
						v-model="pcode"
						placeholder="请输入SPU编号"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>销售门店：</span>
					<el-select
						size="mini"
						class="name-input"
						v-model="shopIds"
						filterable
						multiple
						collapse-tags
						placeholder="请选择门店名称">
						<template v-for="item in shopNameList">
							<el-option
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>三方编号：</span>
					<el-input
						v-model="matchcode"
						placeholder="请输入三方编号"
						class="name-input"
			@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>客户状态：</span>
					<el-select v-model="cusDisabledFlag" class="select-box" size='mini'>
						<el-option :value="null" label="全部"></el-option>
						<el-option :value="0" label="启用"></el-option>
						<el-option :value="1" label="停用"></el-option>
					</el-select>
				</div>
			</div>
			<div class="input-box-btn">
				<el-button size="small" type="text" class="btn" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
				</el-button>
				<el-button type='primary' size='mini' class="fx-btn" @click="search">查询</el-button>
				<el-button plain size='mini' class="fx-btn" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="btn-ship-box" v-if="isCus">
			<el-button type='primary' v-if="AuthorityList['03_0005_0001_00']" plain size='mini' class="fx-big-btn" @click="addClick">添加商品</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0005_0002_00']" plain size='mini' :disabled="!onlyOne" @click='copyClick'>复制到其他客户</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0005_0003_00']" plain size='mini' @click='synchroClick'>同步到其他客户</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0005_0008_00']" plain size='mini' @click="deleteListClick" class="fx-big-btn">删除</el-button>
			<div class="batch-register-btn" @click="privateClick1">
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导入模版</span>
			</div>
			<div v-if="AuthorityList['03_0005_0009_00']" class="batch-register-btn" @click="privateClick">
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导入</span>
			</div>
			<div v-if="AuthorityList['03_0005_0010_00']" class="batch-register-btn"  @click="privateDownloadClick" >
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导出明细</span>
			</div>
		</div>
		<div class="btn-ship-box" v-if="!isCus">
			<el-button type='primary' v-if="AuthorityList['03_0005_0004_00']" plain size='mini' class="fx-big-btn" @click="addClick1">添加客户</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0005_0005_00']" plain size='mini' :disabled="!onlyOne" @click='copyClick1'>复制到其他私密商品</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0005_0006_00']" plain size='mini' @click='synchroClick1'>同步到其他私密商品</el-button>
			<el-button type='primary' v-if="AuthorityList['03_0005_0008_00']" plain size='mini' @click="deleteListClick" class="fx-big-btn">删除</el-button>
			<div class="batch-register-btn" @click="privateClick1">
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导入模版</span>
			</div>
			<div v-if="AuthorityList['03_0005_0009_00']" class="batch-register-btn" @click="privateClick">
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导入</span>
			</div>
			<div v-if="AuthorityList['03_0005_0010_00']" class="batch-register-btn"  @click="privateDownloadClick" >
				<i class="excel-icon import-excel-icon"/>
				<span>私密商品导出明细</span>
			</div>
		</div>
		<input type="file" ref="file" id="file" accept=".xlsx" v-show="false" @change="getFile">
		<div class='table-box'>
			<el-table
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				ref="table"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
				border>
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column
					label="客户名称"
					prop='customerName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="客户类别"
					prop='ccName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="商品名称"
					prop='productname'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<div style="white-space: pre-wrap">{{scope.row.productname}}</div>
					</template>
				</el-table-column>
				<el-table-column
					label="店铺级大类"
					prop='bigcategory'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					v-if="bigcategoryview === 1"
					label="店铺级小类"
					prop='smallcategory'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="销售门店"
					prop='shopname'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="SPU编号"
					prop='productCode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="三方编号"
					prop='matchCode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="规格值"
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<div v-for="(item, index) in scope.row.attrList" :key="index">
							<div class="overhidden">{{item.attrplanName}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="SKU编号"
					prop='attrplanCode'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<div v-for="(item, index) in scope.row.attrList" :key="index">
							<div>{{item.attrplanCode}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="是否在小程序显示"
					prop='showflag'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<div v-for="(item, index) in scope.row.attrList" :key="index">
							<el-switch
								@change="showflagChange(scope.row, item)"
								v-model="item.showflag"
								active-color="#13ce66"
								inactive-color="#ff4949"
								:active-value="1"
								:inactive-value="0">
							</el-switch>
						</div>
					</template>
				</el-table-column>
				<el-table-column fixed="right"  v-if="AuthorityList['03_0005_0007_00']" label="操作" width="100" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type='text' @click="deleteClick(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog class="detail-dialog-title" title="添加商品" top='60px' :before-close='closeAdd' :visible.sync="addModal" width='1200px' :close-on-click-modal="false">
				<addGood :addModal='addModal' :customerName='cusNameLeft' @cancel='closeAdd' :customerid="customerid"/>
			</el-dialog>
			<el-dialog class="detail-dialog-title" title="添加客户" top='60px' :before-close='closeAdd' :visible.sync="addModal1" width='1200px' :close-on-click-modal="false">
				<addCus v-if="addModal1" @cancel='closeAdd' :proName="proNameLeft" :proId="proId"/>
			</el-dialog>
			<el-dialog class="detail-dialog-title" :title="copyFlag === 1 ? '复制到其他客户' : '同步到其他客户'" top='60px' :before-close='closeCopy' :visible.sync="copyModal" width='1200px' :close-on-click-modal="false">
				<copy v-if="copyModal" :customerName='cusNameLeft' :customerid="customerid" :copyModal='copyModal' :copyFlag='copyFlag' :syscode='syscode' :isRelationship='true' :ppIds='ids' @cancel='closeCopy' ref="refCopy"/>
			</el-dialog>
			<el-dialog class="detail-dialog-title" :title="copyFlag === 1 ? '复制到其他私密商品' : '同步到其他私密商品'" top='60px' :before-close='closeCopy1' :visible.sync="copyModal1" width='1200px' :close-on-click-modal="false">
				<copyPro v-if="copyModal1" :proName="proNameLeft" @cancel='closeCopy1' :proId="copyProId" :syscodeIds="syscodeIds" :copyFlag="copyFlag" :chooseArr="ids" ref="refCopy"/>
			</el-dialog>
			<el-dialog title="提示" class="detail-dialog-title" top='60px' :visible.sync="errorMsgModel" width='400px' :close-on-click-modal="false">
				<div style="margin-bottom:10rpx;max-height:250px;overflow:auto">
					<div class="errormsgText" v-for="(item,index) in errorMsgList" :key='index' >
						{{item}}
					</div>
				</div>
				<div style="width:100%;text-align: center;margin-top:10px">
					<el-button size="small" style="width: 120px;" plain type="primary" @click="errorMsgClick">确认</el-button>
				</div>
			</el-dialog>
		</div>
		<div style="margin-top:5px">
			<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="page.num"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="page.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import addGood from '@/components/customerAndProduct/addGood_1.vue'
import addCus from '@/components/customerAndProduct/addCus.vue'
import copy from '@/components/customerAndProduct/copy1.vue'
import copyPro from '@/components/customerAndProduct/copy.vue'
export default {
	name: 'table-box',
	components: {
		addGood, copy, addCus, copyPro
	},
	props: {
		id: String
	},
	data () {
		return {
			syscodeIds: '',
			copyProId: '',
			cusName: '',
			onlyOne: true,
			shopid: '',
			syscode: '',
			cusCateIds: '',
			cusCateList: [],
			shopList: [],
			customerName: '',
			isDisabled: true,
			addModal: false,
			addModal1: false,
			copyModal: false,
			copyModal1: false,
			pName: '',
			tableHeight: '100%',
			page: {
				size: 20,
				num: 1
			},
			total: null,
			tableData: [],
			errorMsgModel: false,
			errorMsgList: [],
			AuthorityList: {
				'03_0005_0001_00': false,
				'03_0005_0002_00': false,
				'03_0005_0003_00': false,
				'03_0005_0004_00': false,
				'03_0005_0005_00': false,
				'03_0005_0006_00': false,
				'03_0005_0007_00': false,
				'03_0005_0008_00': false,
				'03_0005_0009_00': false,
				'03_0005_0010_00': false
			},
			bigcategoryview: 0,
			pcode: '',
			isCus: true,
			matchcode: '',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'relProductCustomerId',
				selectHandler: this.tableSelectUtilsHandler
			}),
			shopIds: [],
			shopNameList: [],
			copyFlag: 0,
			proId: '',
			bigTypeCategory: '',
			smallTypeCategory: '',
			cusCategoryId: '',
			bcId: '',
			scId: '',
			customerid: '',
			cusNameLeft: '',
			proNameLeft: '',
			isChoose: false,
			bc: [],
			sc: [],
			cusDisabledFlag: null,
			collapse: false
		}
	},
	created () {
		this.getAuthority('03_0005_0000_00')
		this.checkSmallCategory()
		this.getShopList()
		this.getCustomer()
		this.getBigCategory()
		this.getSmalCategory()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		handleCollapse () {
			this.collapse = !this.collapse
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		bcChange () {
			this.scId = ''
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.cusCateList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		changeData (data, flag) {
			this.customerid = data.cusId
			this.cusCategoryId = data.cusCategoryId
			this.keyword = data.keyword
			this.proId = data.proId
			this.bigTypeCategory = data.bigTypeCategory
			this.smallTypeCategory = data.smallTypeCategory
			this.cusNameLeft = data.cusName
			this.proNameLeft = data.proName
			this.smallTypeCategory = data.smallTypeCategory
			this.isChoose = data.isChoose
			this.isCus = data.isActive === 'isCus'
			this.page = {
				size: 20,
				num: 1
			}
			this.total = 0
			this.tableData = []
			if (flag) {
				this.tableReload()
			} else {
				this.$message({
					message: '请点击查询获取数据！',
					type: 'warning'
				})
			}
			this.onlyOne = true
			this.tableSelectUtils.clear()
			this.$refs.table.doLayout()
		},
		showflagChange (row, item) {
			let params = [{
				id: item.productid,
				shopid: row.shopid,
				customerid: row.customerid,
				relProductCustomerId: row.relProductCustomerId,
				attrplanId: item.attrplanId,
				showAppFlag: item.showflag
			}]
			let info = `客户【${row.customerName}】将商品【${row.productname}】规格【${item.attrplanName}】是否在小程序显示修改为${item.showflag ? '是' : '否'}`
			let changeData = {
				pre: { showflag: {} },
				cur: { showflag: { msg: info } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.update', changeData)
			this.$store.dispatch('requestFilePost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/showflag`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
					this.tableReload()
				}
			})
		},
		tableSelectUtilsHandler (row) {
			return {
				id: row.productid,
				shopid: row.shopid,
				customerid: row.customerid,
				relProductCustomerId: row.relProductCustomerId,
				customerSyscodeId: row.customerSyscodeId,
				pname: row.productname,
				shopname: row.shopname,
				customerName: row.customerName
			}
		},
		errorMsgClick () {
			this.errorMsgModel = false
		},
		getFile (e) {
			let files = e.target.files[0]
			console.log(files)
			this.uploadPrivateHandle()
			this.$refs.file.value = ''
		},
		uploadPrivateHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/customer/importCustomerProductExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.$message.success('导入成功！')
						this.tableReload()
					} else {
						this.errorMsgList = res.data
						this.errorMsgModel = true
					}
				})
			})
		},
		privateClick1 () {
			let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/customers/product/私密商品导入模版.xlsx?timeStamp=' + new Date().getTime()
			window.location.href = url
		},
		privateClick () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		privateDownloadClick () {
			let params = {
				customerName: this.cusName,
				customercategoryIds: this.cusCateIds,
				customercategoryId: this.cusCategoryId,
				bigTypeCategorys: this.bcId,
				smallTypeCategorys: this.scId,
				customerid: this.customerid,
				productName: this.pName,
				productCode: this.pcode,
				matchCode: this.matchcode,
				id: this.proId,
				bigTypeCategory: this.bigTypeCategory,
				smallTypeCategory: this.smallTypeCategory,
				shopIds: +this.shopIds ? this.shopIds : null,
				cusDisabledFlag: this.cusDisabledFlag
			}
			// console.log(this.ids)
			if (this.ids.length !== 0) {
				let list = this.ids
				let data = []
				for (let i = 0; i < list.length; i++) {
					data.push(list[i].id)
				}
				params.ids = data.join(',')
			} else {
				params.ids = ''
			}
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/customer/exportCustomerProductExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.privateDownload(blobUrl, 1)
			}
			req.send(JSON.stringify(params))
		},
		privateDownload (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()
			let name = '客户与商品关系详情(' + year + '-' + month + '-' + day + ').xlsx'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
			// })
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		closeAdd () {
			this.addModal = false
			this.addModal1 = false
			this.page = {
				size: 20,
				num: 1
			}
			this.tableSelectUtils.clear()
			this.tableReload()
		},
		closeCopy1 () {
			this.tableSelectUtils.clear()
			this.copyModal1 = false
			this.tableReload()
		},
		closeCopy () {
			this.tableSelectUtils.clear()
			this.copyModal = false
			this.$refs.refCopy.name = ''
			this.$refs.refCopy.lineName = ''
			this.$refs.refCopy.customercategoryid = -1
			this.$refs.refCopy.disabledflag = 2
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		getCode (num, cusId) {
			let id = ''
			if (cusId) {
				id = cusId
				this.customerid = cusId
			} else {
				id = this.customerid
			}
			let params = {
				id: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findCustomerDetailInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.syscode = res.data.syscode + ''
					this.copyFlag = num // 1.复制到其他客户 2.同步到其他客户 3.同步客户订货周期
					this.copyModal = true
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		synchroClick1 () {
			if (!this.isChoose) {
				this.$message.error('请选择商品！')
				return false
			}
			this.copyFlag = 2
			this.copyProId = this.proId
			let arr = []
			this.ids.forEach(item => {
				arr.push(item.customerSyscodeId)
			})
			arr = Array.from(new Set(arr))
			this.syscodeIds = arr.join(',')
			this.copyModal1 = true
		},
		synchroClick () {
			if (!this.isChoose) {
				this.$message.error('请选择客户！')
				return false
			}
			this.getCode(2)
		},
		copyClick1 () {
			if (this.ids.length === 0) {
				this.$message.error('请勾选客户，再点击【复制至其他客户】按钮！')
				return false
			}
			this.copyFlag = 1
			this.copyProId = this.ids[0].id
			let arr = []
			this.ids.forEach(item => {
				arr.push(item.customerSyscodeId)
			})
			arr = Array.from(new Set(arr))
			this.syscodeIds = arr.join(',')
			this.copyModal1 = true
		},
		copyClick () {
			if (this.ids.length === 0) {
				this.$message.error('请勾选商品，再点击【复制至其他客户】按钮！')
				return false
			}
			let id = this.ids[0].customerid
			this.getCode(1, id)
		},
		addClick1 () {
			if (!this.isChoose) {
				this.$message.error('请选择商品！')
				return false
			}
			this.addModal1 = true
		},
		addClick () {
			if (!this.isChoose) {
				this.$message.error('请选择客户！')
				return false
			}
			this.addModal = true
		},
		search () {
			this.tableSelectUtils.clear()
			this.page.num = 1
			this.tableReload()
		},
		clear () {
			this.pName = ''
			this.pcode = ''
			this.shopIds = []
			this.matchcode = ''
			this.cusName = ''
			this.scId = ''
			this.bcId = ''
			this.cusCateIds = ''
			this.cusDisabledFlag = null
			this.search()
		},
		deleteClick (data) {
			let params = [
				{
					customerid: data.customerid,
					id: data.productid,
					shopid: data.shopid,
					relProductCustomerId: data.relProductCustomerId
				}
			]
			let changeData = {
				info: `删除“客户：${data.customerName}“与”私密商品：${data.productname}“，“销售门店：${data.shopname}”的绑定关系`
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.info', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/delrelproductcustomer`,
				data: params,
				logger
			}).then(res => {
				if (res.resultFlag) {
					this.tableReload()
					this.tableSelectUtils.clear()
					this.$message.success('删除成功！')
				} else {
					this.$message.error(res.message)
				}
			})
		},
		deleteListClick () {
			if (this.ids.length === 0) {
				this.$message.error('请勾选商品')
				return false
			}
			this.$confirm('提示是否要删除勾选的商品', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.deleteList()
			}).catch(() => {
			})
		},
		deleteList () {
			let logArr = []
			this.ids.forEach(item => {
				let text = `删除“客户：${item.customerName}“与”私密商品：${item.pname}“，“销售门店：${item.shopname}”的绑定关系`
				logArr.push(text)
			})
			let changeData = {
				info: logArr.join(',')
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.info', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/delrelproductcustomer`,
				data: this.ids,
				logger
			}).then(res => {
				// console.log(res)
				if (res.resultFlag) {
					this.tableSelectUtils.clear()
					this.tableReload()
					this.$message.success('删除成功！')
				} else {
					this.$message.error(res.message)
				}
			})
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			let list = this.ids
			let arr = list.map(item => {
				if (this.isCus) {
					return item.customerid
				} else {
					return item.id
				}
			})
			let length = new Set(arr).size
			if (length > 1) {
				this.onlyOne = false
			} else {
				this.onlyOne = true
			}
		},
		tableReload () {
			let params = {
				customerName: this.cusName,
				customercategoryIds: this.cusCateIds,
				customercategoryId: this.cusCategoryId,
				bigTypeCategorys: this.bcId,
				smallTypeCategorys: this.scId,
				customerid: this.customerid,
				shopIds: this.shopIds,
				productName: this.pName,
				page: this.page.num,
				size: this.page.size,
				productCode: this.pcode,
				matchCode: this.matchcode,
				id: this.proId,
				bigTypeCategory: this.bigTypeCategory,
				smallTypeCategory: this.smallTypeCategory,
				cusDisabledFlag: this.cusDisabledFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findproductbycustomer`,
				data: params
			}).then(res => {
				this.tableData = res.recordList ? res.recordList : []
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
					this.$refs.table.doLayout()
				})
				this.total = res.recordCount
			})
		},
		handleSizeChange (val) {
			this.page.num = 1
			this.page.size = val
			this.tableReload()
		},
		handlePageChange (val) {
			this.page.num = val
			this.tableReload()
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopNameList = res
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.overhidden{
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.container2{
	display: flex;
	width: 100%;
	flex-direction: column !important;
	height:100%;
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 10px;
        display: flex;
        width: 120px;
        height: 32px;
        justify-content center;
        align-items center;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	.errormsgText{
		width:100%;
		text-align :left
		line-height:30px;
	}
	.cusApro-search {
		width:100%;
		line-height :40px;
		display:flex;
		border-bottom 1px solid #dce2fd
	}
	.search-box{
		display:flex;
		flex-wrap:wrap;
		overflow: hidden;
        .select-input{
            width :120px
        }
		.input-box{
			text-align :left
			// width :260px;
			margin-bottom:10px
			&>span {
				display: inline-block;
				text-align: right;
				width: 75px;
				margin-right: 5px
			}
			.name-input {
				width: 160px;
				margin-right: 10px;
			}
			.select-box{
				width:160px;
				margin-right:10px;
			}
		}
	}
	.input-box-btn{
		width: 200px;
		flex-shrink: 0
	}
	.name-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box{
			text-align :left
			overflow-x :hidden
			margin-bottom:10px
		}
	}
	.btn-ship-box{
		margin-top:10px;
		display :flex
	}
	.table-box{
		flex: 1;
		margin-top:8px;
	}
}

</style>
<style lang="stylus">
.el-dialog__header{
    text-align left
}
.el-dialog__body {
	padding-top: 10px;
	padding-bottom: 10px
}
</style>
